<router-outlet> </router-outlet>
<!--<rmi-cookie-policy-->
<!--  *ngIf="showCookieDialog"-->
<!--  (setCookieEvent)="setCookie($event)"-->
<!--&gt;</rmi-cookie-policy>-->
